import { LoaderNew } from "@brightagency/headstart-common";
import React from "react";
import { ListingItemContent } from "./ListingItemContent";
import { useListingData } from "./services";
import { Outer } from "./styled";

interface Props {
    slug: string;
}

export const ListingItem: React.FC<Props> = ({ slug }) => {
    const { data, isLoading, error } = useListingData(slug);

    if (error) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: "100px 0",
                    backgroundColor: "white",
                }}
            >
                <h3>Something went wrong, please try again</h3>
            </div>
        );
    }

    if (isLoading || !data) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "100px 0",
                }}
            >
                <LoaderNew />
            </div>
        );
    }

    return (
        <Outer>
            <ListingItemContent listing={data} />
        </Outer>
    );
};
